import { CARD_BACKGROUND_COLOR_PATH } from '../constants/wix-params';
import withSettingsColor from './with-settings-color';

export default withSettingsColor(CARD_BACKGROUND_COLOR_PATH, 'cardBackgroundColor');



// WEBPACK FOOTER //
// ./app/hoc/with-card-background-color.js